// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CategoriesRouteImport } from './routes/categories'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CopyrightRouteImport } from './routes/copyright'
import { Route as DiscoverRouteImport } from './routes/discover'
import { Route as GuidelinesRouteImport } from './routes/guidelines'
import { Route as HelpRouteImport } from './routes/help'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SupportRouteImport } from './routes/support'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TippingRouteImport } from './routes/tipping'
import { Route as AuthenticatedFollowingRouteImport } from './routes/_authenticated/following'
import { Route as AuthenticatedLibraryRouteImport } from './routes/_authenticated/library'
import { Route as AuthenticatedMessagesRouteImport } from './routes/_authenticated/messages'
import { Route as AuthenticatedModerationRouteImport } from './routes/_authenticated/moderation'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedStartWritingRouteImport } from './routes/_authenticated/start-writing'
import { Route as AuthenticatedStudioRouteRouteImport } from './routes/_authenticated/studio/route'
import { Route as AuthenticatedWriteRouteImport } from './routes/_authenticated/write'
import { Route as DevTagInputRouteImport } from './routes/dev.tag-input'
import { Route as StoryStoryIdRouteImport } from './routes/story.$storyId'
import { Route as TagSlugRouteImport } from './routes/tag.$slug'
import { Route as TeamInviteRouteImport } from './routes/team.invite'
import { Route as TeamLoginRouteImport } from './routes/team.login'
import { Route as UUsernameRouteImport } from './routes/u.$username'
import { Route as AuthenticatedAccountStatusRouteImport } from './routes/_authenticated/account/status'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminAuditRouteImport } from './routes/_authenticated/admin/audit'
import { Route as AuthenticatedAdminEmailAnalyticsRouteImport } from './routes/_authenticated/admin/email-analytics'
import { Route as AuthenticatedAdminEmailDeliveryRouteImport } from './routes/_authenticated/admin/email-delivery'
import { Route as AuthenticatedAdminEmailRetriesRouteImport } from './routes/_authenticated/admin/email-retries'
import { Route as AuthenticatedAdminEmailTemplatesRouteImport } from './routes/_authenticated/admin/email-templates'
import { Route as AuthenticatedAdminFinanceRouteImport } from './routes/_authenticated/admin/finance'
import { Route as AuthenticatedAdminOpsSettingsRouteImport } from './routes/_authenticated/admin/ops-settings'
import { Route as AuthenticatedAdminStaffRouteImport } from './routes/_authenticated/admin/staff'
import { Route as AuthenticatedAdminTagsRouteImport } from './routes/_authenticated/admin/tags'
import { Route as AuthenticatedAdminTeamRouteImport } from './routes/_authenticated/admin/team'
import { Route as AuthenticatedAdminTipActionsRouteImport } from './routes/_authenticated/admin/tip-actions'
import { Route as AuthenticatedAdminTipReplayRouteImport } from './routes/_authenticated/admin/tip-replay'
import { Route as AuthenticatedAdminWebhookHealthRouteImport } from './routes/_authenticated/admin/webhook-health'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsProfileImagesRouteImport } from './routes/_authenticated/settings/profile-images'
import { Route as AuthenticatedSettingsRegionRouteImport } from './routes/_authenticated/settings/region'
import { Route as AuthenticatedStudioIndexRouteImport } from './routes/_authenticated/studio/index'
import { Route as AuthenticatedStudioAnalyticsRouteImport } from './routes/_authenticated/studio/analytics'
import { Route as AuthenticatedStudioDraftsRouteImport } from './routes/_authenticated/studio/drafts'
import { Route as AuthenticatedStudioPayoutsRouteImport } from './routes/_authenticated/studio/payouts'
import { Route as AuthenticatedStudioProfileRouteImport } from './routes/_authenticated/studio/profile'
import { Route as AuthenticatedStudioPublicationsRouteImport } from './routes/_authenticated/studio/publications'
import { Route as AuthenticatedStudioSeriesRouteImport } from './routes/_authenticated/studio/series'
import { Route as AuthenticatedStudioSubmissionsRouteImport } from './routes/_authenticated/studio/submissions'
import { Route as AuthenticatedStudioSupportRouteImport } from './routes/_authenticated/studio/support'
import { Route as AuthenticatedAdminMembersPendingRouteImport } from './routes/_authenticated/admin/members/pending'
import { Route as AuthenticatedAdminModerationAgeVerificationRouteImport } from './routes/_authenticated/admin/moderation/age-verification'
import { Route as AuthenticatedAdminModerationImagesRouteImport } from './routes/_authenticated/admin/moderation/images'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const CategoriesRoute = CategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CopyrightRoute = CopyrightRouteImport.update({
            id: '/copyright',path: '/copyright',getParentRoute: () => rootRouteImport
          })
const DiscoverRoute = DiscoverRouteImport.update({
            id: '/discover',path: '/discover',getParentRoute: () => rootRouteImport
          })
const GuidelinesRoute = GuidelinesRouteImport.update({
            id: '/guidelines',path: '/guidelines',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TippingRoute = TippingRouteImport.update({
            id: '/tipping',path: '/tipping',getParentRoute: () => rootRouteImport
          })
const AuthenticatedFollowingRoute = AuthenticatedFollowingRouteImport.update({
            id: '/following',path: '/following',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedLibraryRoute = AuthenticatedLibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMessagesRoute = AuthenticatedMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedModerationRoute = AuthenticatedModerationRouteImport.update({
            id: '/moderation',path: '/moderation',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedNotificationsRoute = AuthenticatedNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsRouteRoute = AuthenticatedSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedStartWritingRoute = AuthenticatedStartWritingRouteImport.update({
            id: '/start-writing',path: '/start-writing',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedStudioRouteRoute = AuthenticatedStudioRouteRouteImport.update({
            id: '/studio',path: '/studio',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedWriteRoute = AuthenticatedWriteRouteImport.update({
            id: '/write',path: '/write',getParentRoute: () => AuthenticatedRouteRoute
          })
const DevTagInputRoute = DevTagInputRouteImport.update({
            id: '/dev/tag-input',path: '/dev/tag-input',getParentRoute: () => rootRouteImport
          })
const StoryStoryIdRoute = StoryStoryIdRouteImport.update({
            id: '/story/$storyId',path: '/story/$storyId',getParentRoute: () => rootRouteImport
          })
const TagSlugRoute = TagSlugRouteImport.update({
            id: '/tag/$slug',path: '/tag/$slug',getParentRoute: () => rootRouteImport
          })
const TeamInviteRoute = TeamInviteRouteImport.update({
            id: '/team/invite',path: '/team/invite',getParentRoute: () => rootRouteImport
          })
const TeamLoginRoute = TeamLoginRouteImport.update({
            id: '/team/login',path: '/team/login',getParentRoute: () => rootRouteImport
          })
const UUsernameRoute = UUsernameRouteImport.update({
            id: '/u/$username',path: '/u/$username',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAccountStatusRoute = AuthenticatedAccountStatusRouteImport.update({
            id: '/account/status',path: '/account/status',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminAuditRoute = AuthenticatedAdminAuditRouteImport.update({
            id: '/admin/audit',path: '/admin/audit',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminEmailAnalyticsRoute = AuthenticatedAdminEmailAnalyticsRouteImport.update({
            id: '/admin/email-analytics',path: '/admin/email-analytics',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminEmailDeliveryRoute = AuthenticatedAdminEmailDeliveryRouteImport.update({
            id: '/admin/email-delivery',path: '/admin/email-delivery',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminEmailRetriesRoute = AuthenticatedAdminEmailRetriesRouteImport.update({
            id: '/admin/email-retries',path: '/admin/email-retries',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminEmailTemplatesRoute = AuthenticatedAdminEmailTemplatesRouteImport.update({
            id: '/admin/email-templates',path: '/admin/email-templates',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminFinanceRoute = AuthenticatedAdminFinanceRouteImport.update({
            id: '/admin/finance',path: '/admin/finance',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminOpsSettingsRoute = AuthenticatedAdminOpsSettingsRouteImport.update({
            id: '/admin/ops-settings',path: '/admin/ops-settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminStaffRoute = AuthenticatedAdminStaffRouteImport.update({
            id: '/admin/staff',path: '/admin/staff',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminTagsRoute = AuthenticatedAdminTagsRouteImport.update({
            id: '/admin/tags',path: '/admin/tags',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminTeamRoute = AuthenticatedAdminTeamRouteImport.update({
            id: '/admin/team',path: '/admin/team',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminTipActionsRoute = AuthenticatedAdminTipActionsRouteImport.update({
            id: '/admin/tip-actions',path: '/admin/tip-actions',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminTipReplayRoute = AuthenticatedAdminTipReplayRouteImport.update({
            id: '/admin/tip-replay',path: '/admin/tip-replay',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminWebhookHealthRoute = AuthenticatedAdminWebhookHealthRouteImport.update({
            id: '/admin/webhook-health',path: '/admin/webhook-health',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsNotificationsRoute = AuthenticatedSettingsNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedSettingsRouteRoute
          })
const AuthenticatedSettingsProfileImagesRoute = AuthenticatedSettingsProfileImagesRouteImport.update({
            id: '/profile-images',path: '/profile-images',getParentRoute: () => AuthenticatedSettingsRouteRoute
          })
const AuthenticatedSettingsRegionRoute = AuthenticatedSettingsRegionRouteImport.update({
            id: '/region',path: '/region',getParentRoute: () => AuthenticatedSettingsRouteRoute
          })
const AuthenticatedStudioIndexRoute = AuthenticatedStudioIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedStudioRouteRoute
          })
const AuthenticatedStudioAnalyticsRoute = AuthenticatedStudioAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthenticatedStudioRouteRoute
          })
const AuthenticatedStudioDraftsRoute = AuthenticatedStudioDraftsRouteImport.update({
            id: '/drafts',path: '/drafts',getParentRoute: () => AuthenticatedStudioRouteRoute
          })
const AuthenticatedStudioPayoutsRoute = AuthenticatedStudioPayoutsRouteImport.update({
            id: '/payouts',path: '/payouts',getParentRoute: () => AuthenticatedStudioRouteRoute
          })
const AuthenticatedStudioProfileRoute = AuthenticatedStudioProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedStudioRouteRoute
          })
const AuthenticatedStudioPublicationsRoute = AuthenticatedStudioPublicationsRouteImport.update({
            id: '/publications',path: '/publications',getParentRoute: () => AuthenticatedStudioRouteRoute
          })
const AuthenticatedStudioSeriesRoute = AuthenticatedStudioSeriesRouteImport.update({
            id: '/series',path: '/series',getParentRoute: () => AuthenticatedStudioRouteRoute
          })
const AuthenticatedStudioSubmissionsRoute = AuthenticatedStudioSubmissionsRouteImport.update({
            id: '/submissions',path: '/submissions',getParentRoute: () => AuthenticatedStudioRouteRoute
          })
const AuthenticatedStudioSupportRoute = AuthenticatedStudioSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AuthenticatedStudioRouteRoute
          })
const AuthenticatedAdminMembersPendingRoute = AuthenticatedAdminMembersPendingRouteImport.update({
            id: '/admin/members/pending',path: '/admin/members/pending',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminModerationAgeVerificationRoute = AuthenticatedAdminModerationAgeVerificationRouteImport.update({
            id: '/admin/moderation/age-verification',path: '/admin/moderation/age-verification',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminModerationImagesRoute = AuthenticatedAdminModerationImagesRouteImport.update({
            id: '/admin/moderation/images',path: '/admin/moderation/images',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedSettingsRouteRouteChildren = {
  AuthenticatedSettingsNotificationsRoute: AuthenticatedSettingsNotificationsRoute,AuthenticatedSettingsProfileImagesRoute: AuthenticatedSettingsProfileImagesRoute,AuthenticatedSettingsRegionRoute: AuthenticatedSettingsRegionRoute
}

const AuthenticatedSettingsRouteRouteWithChildren = AuthenticatedSettingsRouteRoute._addFileChildren(AuthenticatedSettingsRouteRouteChildren)




const AuthenticatedStudioRouteRouteChildren = {
  AuthenticatedStudioAnalyticsRoute: AuthenticatedStudioAnalyticsRoute,AuthenticatedStudioDraftsRoute: AuthenticatedStudioDraftsRoute,AuthenticatedStudioPayoutsRoute: AuthenticatedStudioPayoutsRoute,AuthenticatedStudioProfileRoute: AuthenticatedStudioProfileRoute,AuthenticatedStudioPublicationsRoute: AuthenticatedStudioPublicationsRoute,AuthenticatedStudioSeriesRoute: AuthenticatedStudioSeriesRoute,AuthenticatedStudioSubmissionsRoute: AuthenticatedStudioSubmissionsRoute,AuthenticatedStudioSupportRoute: AuthenticatedStudioSupportRoute,AuthenticatedStudioIndexRoute: AuthenticatedStudioIndexRoute
}

const AuthenticatedStudioRouteRouteWithChildren = AuthenticatedStudioRouteRoute._addFileChildren(AuthenticatedStudioRouteRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,AuthenticatedStudioRouteRoute: AuthenticatedStudioRouteRouteWithChildren,AuthenticatedFollowingRoute: AuthenticatedFollowingRoute,AuthenticatedLibraryRoute: AuthenticatedLibraryRoute,AuthenticatedMessagesRoute: AuthenticatedMessagesRoute,AuthenticatedModerationRoute: AuthenticatedModerationRoute,AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,AuthenticatedStartWritingRoute: AuthenticatedStartWritingRoute,AuthenticatedWriteRoute: AuthenticatedWriteRoute,AuthenticatedAccountStatusRoute: AuthenticatedAccountStatusRoute,AuthenticatedAdminAuditRoute: AuthenticatedAdminAuditRoute,AuthenticatedAdminEmailAnalyticsRoute: AuthenticatedAdminEmailAnalyticsRoute,AuthenticatedAdminEmailDeliveryRoute: AuthenticatedAdminEmailDeliveryRoute,AuthenticatedAdminEmailRetriesRoute: AuthenticatedAdminEmailRetriesRoute,AuthenticatedAdminEmailTemplatesRoute: AuthenticatedAdminEmailTemplatesRoute,AuthenticatedAdminFinanceRoute: AuthenticatedAdminFinanceRoute,AuthenticatedAdminOpsSettingsRoute: AuthenticatedAdminOpsSettingsRoute,AuthenticatedAdminStaffRoute: AuthenticatedAdminStaffRoute,AuthenticatedAdminTagsRoute: AuthenticatedAdminTagsRoute,AuthenticatedAdminTeamRoute: AuthenticatedAdminTeamRoute,AuthenticatedAdminTipActionsRoute: AuthenticatedAdminTipActionsRoute,AuthenticatedAdminTipReplayRoute: AuthenticatedAdminTipReplayRoute,AuthenticatedAdminWebhookHealthRoute: AuthenticatedAdminWebhookHealthRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminMembersPendingRoute: AuthenticatedAdminMembersPendingRoute,AuthenticatedAdminModerationAgeVerificationRoute: AuthenticatedAdminModerationAgeVerificationRoute,AuthenticatedAdminModerationImagesRoute: AuthenticatedAdminModerationImagesRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuthRoute: AuthRoute,CategoriesRoute: CategoriesRoute,ContactRoute: ContactRoute,CopyrightRoute: CopyrightRoute,DiscoverRoute: DiscoverRoute,GuidelinesRoute: GuidelinesRoute,HelpRoute: HelpRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SupportRoute: SupportRoute,TermsRoute: TermsRoute,TippingRoute: TippingRoute,DevTagInputRoute: DevTagInputRoute,StoryStoryIdRoute: StoryStoryIdRoute,TagSlugRoute: TagSlugRoute,TeamInviteRoute: TeamInviteRoute,TeamLoginRoute: TeamLoginRoute,UUsernameRoute: UUsernameRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)